import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MostrarItemComponent } from './mostrar-item.component';
import { PipesModule } from '../../../../pipes/pipes.module';
import { MaterialModule } from '../../../../components/material/material.module';

@NgModule({
  declarations: [
    MostrarItemComponent,
  ],
  imports: [
    CommonModule,
    PipesModule,
    MaterialModule,
  ],
  exports: [
    MostrarItemComponent,
  ]
})
export class MostrarItemModule { }
